export const version = "bytes/5.0.10";
//# sourceMappingURL=_version.js.map